import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "overall",
  templateUrl: "./overall.component.html",
  styleUrls: ["./overall.component.scss"],
})
export class OverallComponent implements OnInit {
  toolTipText: string;
  @Input()
  chartData;
  @Input()
  dataSuffix;
  @Input()
  dataPrefix;
  @Input()
  trendSuffix;
  @Input()
  title;
  @Input()
  color;
  @Input()
  upIsGood;
  @Input()
  entityLevel;
  @Input()
  overallSubtitle;
  @Input()
  studentFirstName;
  @Input()
  roundTo = 0;
  @Input()
  hideSubtitle = false;
  @Input()
  filterSentence: string;
  @Input()
  isFreckleMetric: boolean;

  trend;
  trendImg;
  partialImagePath: string = "../../assets/images/";
  overallDescriptor: string = "denominatorDescriptor";
  isMegaLargeNumber: boolean = false;

  ngOnInit() {
    if (this.chartData.length > 1) {
      this.trend =
        Math.round((this.chartData[0].y - this.chartData[1].y) * 10) / 10;
      if (this.trend > 0) {
        if (this.upIsGood === true) {
          this.trendImg = "up_good.png";
        } else if (this.upIsGood === false) {
          this.trendImg = "up_bad.png";
        } else {
          this.trendImg = "up_gray.png";
        }
      } else if (this.trend < 0) {
        if (this.upIsGood === true) {
          this.trendImg = "down_bad.png";
        } else if (this.upIsGood === false) {
          this.trendImg = "down_good.png";
        } else {
          this.trendImg = "down_gray.png";
        }
      } else {
        // no change has happened
        this.trendImg = "sideways_arrow_gray.png";
      }
    }
    this.getTooltipText();
    this.isMegaLargeNumber =
      this.chartData && this.chartData[0] && this.chartData[0].y
        ? parseFloat(this.chartData[0].y) > 1000000
        : false;
  }

  ngOnChanges() {
    this.getTooltipText();
  }

  getTooltipText() {
    if (this.entityLevel !== "student" && this.entityLevel !== "usage") {
      if (this.dataSuffix === "") {
        this.toolTipText =
          (this.dataPrefix || "") +
          "<strong>" +
          (this.chartData[0].numerator != null
            ? this.chartData[0].numerator.toLocaleString()
            : "") +
          "</strong> " +
          this.chartData[0].descriptor;
      } else {
        this.toolTipText =
          (this.dataPrefix || "") +
          "<strong>" +
          (this.chartData[0].numerator != null
            ? this.chartData[0].numerator.toLocaleString()
            : "") +
          "</strong> of <strong>" +
          (this.dataPrefix || "") +
          (this.chartData[0].denominator != null
            ? this.chartData[0].denominator.toLocaleString()
            : "") +
          "</strong> " +
          this.chartData[0].descriptor;
      }
    } else if (this.entityLevel === "student") {
      this.toolTipText =
        (this.studentFirstName !== "" && this.studentFirstName !== "-----"
          ? this.studentFirstName
          : "This student") +
        " " +
        this.chartData[0].descriptor;
    } else {
      this.toolTipText =
        (this.dataPrefix || "") +
        "<strong>" +
        this.chartData[0].numerator +
        "</strong> out of <strong>" +
        (this.dataPrefix || "") +
        this.chartData[0].denominator +
        "</strong> " +
        this.chartData[0].descriptor +
        " in the current month";
    }
  }

  getPositiveVal(val) {
    return Math.abs(val);
  }
}
